import { render } from "./SliderTwo.vue?vue&type=template&id=3cbf0552"
import script from "./SliderTwo.vue?vue&type=script&lang=js"
export * from "./SliderTwo.vue?vue&type=script&lang=js"

import "./SliderTwo.vue?vue&type=style&index=0&id=3cbf0552&lang=css"
script.render = render

export default script